import clsx from 'clsx';

import { types } from './shared';
import { Button, Slug } from '../../components';
import type { Item } from './usePrompts';

type PromptsListProps = {
  data: Item[];
  updating: boolean;

  onStartEdit: (item: Item) => void;
  onStartDelete: (item: Item) => void;
};

export const PromptsList: React.FC<PromptsListProps> = ({
  data,
  updating,

  onStartEdit,
  onStartDelete,
}) => {
  return (
    <>
      <div className="flex flex-col gap-y-xl overflow-y-auto pr-xl flex-1">
        {data.map(item => {
          const type = types.find(t => t.value === item.prompt_type);

          return (
            <div
              key={item.id}
              className="flex flex-col rounded-md shrink-0 gap-y-sm bg-bg p-lg group"
            >
              <div className="flex flex-row flex-1 gap-x-2xl gap-y-sm flex-wrap items-center">
                <div className="font-semibold truncate">{item.name}</div>
                <div className="flex flex-row gap-x-xs invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-def shrink-0">
                  <Button
                    icon="edit"
                    type="primary"
                    disabled={updating}
                    onClick={() => onStartEdit(item)}
                  />
                  <Button
                    icon="delete"
                    type="danger"
                    disabled={updating}
                    onClick={() => onStartDelete(item)}
                  />
                </div>
              </div>
              <div className="flex flex-row gap-sm items-center flex-wrap">
                <Slug
                  className="w-fit"
                  text={type?.label || item.prompt_type}
                />
                <Slug
                  text={item.is_active ? 'Active' : 'Inactive'}
                  color={item.is_active ? 'success' : 'warning'}
                />
                <span className="text-tiny italic font-semibold">
                  Version: {item.version}
                </span>
              </div>
              <div
                style={{ fontFamily: "'Courier New', monospace" }}
                className={clsx(
                  'bg-content text-tiny font-semibold whitespace-pre-wrap overflow-y-auto max-h-[20rem] rounded-sm p-md'
                )}
              >
                {item.content}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
